/** @file Keeps the compiled store on the viewed document (confirmed + pending) while the viewport is mounted. */
import { currentDoc } from './currentDoc';
import { docStore } from './docStore';
import { syncCompiled } from './syncCompiled';

/** Syncs now and on every doc-store change; the disposer stops and clears the compiled store. */
export function installCompiledSync(): () => void {
  const sync = (): void => { syncCompiled(currentDoc(docStore.getState())); };
  sync();
  const stop = docStore.subscribe(sync);
  return () => { stop(); syncCompiled(null); };
}
